<div class="mb-8">

    @let myRoles = (myRoles$ | async);

    <div class="w-full flex justify-between mt-8 mb-4">
        <app-btn-back routeTo=".." icon="fa fa-close" btnText="Cancel"></app-btn-back>
    </div>

    <div class="border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            {{gradeLesson?.lessonName}} - Add Notes
        </h1>
    </div>

    <div class="w-full mb-6">
        <form [formGroup]="pageForm" (ngSubmit)="create()">

            <div class="flex flex-wrap py-4">

                <div class="w-full mt-4 mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="name">Notes Name
                        *</label>
                    <input type="text" name="name" id="name" formControlName="name" placeholder="Notes Name" required
                        class="appearance-none placeholder-blueGray-300 bg-white rounded text-sm shadow border-0 focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                    <div
                        class="{{ pageForm.get('name')?.invalid && (pageForm.get('name')?.dirty || pageForm.get('name')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        @if (pageForm.get('name')?.errors?.['required']) {
                        <p>
                            Value is required
                        </p>
                        } @else if(pageForm.get('name')?.errors?.['minlength'] ||
                        pageForm.get('name')?.errors?.['maxlength']) {
                        <p>
                            Min 10 and max 50 characters required
                        </p>
                        }
                    </div>
                </div>

                <div class="w-full flex flex-col gap-1 mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Notes Type
                    </label>
                    <select (change)="onChangeType($event)"
                        class="appearance-none placeholder-blueGray-300 bg-white rounded text-sm shadow border-0 focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                        @for (item of notesList; track item) {
                        <option [selected]="pageForm.get('type')?.value == item" [value]="item"
                            class="bg-white text-primary-500 text-sm">
                            {{item}}</option>
                        }
                    </select>
                </div>

                @if (pageForm.get('type')?.value == noteTypes.pdf) {
                <div class="w-full flex flex-col mt-4">
                    <app-s3-document-upload #uploader label="Upload Pdf" [preSignedUrlEndpoint]="preSignedUrlEndpoint"
                        [apikey]="apiKey" [formats]="['.pdf']"
                        [cloudFrontDomain]="cloudFrontDomain"></app-s3-document-upload>
                </div>
                } @else if (pageForm.get('type')?.value == noteTypes.text) {
                <p>Management: {{myRoles.management}}</p>
                <p>Faculty: {{myRoles.faculty}}</p>
                <p>Teacher ID: {{grade?.teacherId}}</p>
                <p>User ID: {{user?.uid}}</p>

                <div class="rounded-t block w-full overflow-x-auto shadow-lg rounded bg-white my-4">
                    <rich-text-editor [jsonFormat]="htmlData" (contentChanged)="onContentChanged($event)"
                        [isEditable]="(myRoles?.management || myRoles?.faculty || grade?.teacherId === user?.uid)"
                        class="w-full"></rich-text-editor>
                </div>
                }
                <div class="w-full">
                    <app-btn-submit
                        [isDisabled]="!pageForm.valid || ((loadingTeacherNotes$ | async) ?? false) || !(pageForm.get('type')?.value == noteTypes.pdf ? uploader?.getIsAttached() : true) || (pageForm.get('type')?.value == noteTypes.text && !htmlData)"
                        [isLoading]="(loadingTeacherNotes$ | async) ?? false" [actionText]="'Create'"
                        [icon]="'fa fa-save'"></app-btn-submit>
                </div>
            </div>
        </form>
    </div>
</div>